// Types -> names
export const BY_SPECIES = "by_species";
export const BY_CLUSTER = "by_cluster";
export const BY_CELL = "by_cell";

// Color by
export const BY_RECORDS = "by_records";
export const BY_SPECIES_RICHNESS = "by_species_richness";

export const PANEL_DATA = 0;
export const PANEL_INFO = 1;
export const PANEL_MAP = 2;
